import React, { useState, useEffect, useRef } from "react";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Col, Card } from 'antd'

import Utils from "../Common/Utils.js";

const GraphPopup = (props) => {
    // ###### RENDER FUNCTIONS ######
    const { classes } = props;

    const { Meta } = Card;

    // Close the modal when pressing Escape
    useEffect(() => {
        if (!props.onClose) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') props.onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [props.onClose]);

    const graphSelection = () => {
        let to_display
        switch (props.inside_props.type) {
            case "tuckyTemperature" :
                to_display = Utils.display_temperatureGraph(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "oximeterPulseRate" :
            case "oximeterSPO2" :
                to_display = Utils.display_pulseOximeterGraph(props.inside_props, 200, props.new_window)
                break;
            case "tensiometerPulseRate" :
            case "tensiometerBloodpressure" :
                to_display = Utils.display_tensiometerGraph(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "scaleWeight" :
                to_display = Utils.display_scaleGraph(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "pain" :
                to_display = Utils.display_painGraph(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "EQ5D" :
            case "EQ5DHealthscale" :
                to_display = Utils.display_formEQ5DGraph(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "SF36" :
                to_display = Utils.display_SF36Graph(props.inside_props, props.new_window)
                break;
            case "MDASI" :
                to_display = Utils.display_MDASIGraph(props.inside_props, props.new_window)
                break;
            case "Alimentation" :
                to_display = Utils.display_AlimentationGraph(props.inside_props, props.new_window)
                break;
            case "NIVRate" :
                to_display = Utils.display_breathingGraph_NIVBreathingRate(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "NIVLeak" :
                to_display = Utils.display_breathingGraph_NIVLeakage(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "NIVUsage" :
                to_display = Utils.display_breathingGraph_NIVUsage(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "OxiRate" :
                to_display = Utils.display_breathingGraph_OxygenFlowRate(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "OxiUsage" :
                to_display = Utils.display_breathingGraph_OxiUsage(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "AHI" :
                to_display = Utils.display_breathingGraph_AHI(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
            case "Leak95" :
                to_display = Utils.display_breathingGraph_Leak95(props.inside_props, props.new_window, props.inside_props.popupNum)
                break;
        }
        return (
            <Card
                id="box-extended-view2"
                style={{ width: "100%", height: "100%" }}
                bodyStyle={{ width: "100%", height: "100%", padding: 12 }}
            >
                {to_display}
            </Card>
        )
    }

    const titleSelection = () => {
        let to_display
        switch (props.inside_props.type) {
            case "tuckyTemperature" :
                to_display = <FormattedMessage id="patientConstants.temperature" defaultMessage="Temperature" />
                break;
            case "oximeterPulseRate" :
            case "oximeterSPO2" :
                to_display = <FormattedMessage id="device.oximeter.name" defaultMessage="Oximeter" />
                break;
            case "tensiometerPulseRate" :
            case "tensiometerBloodpressure" :
                to_display = <FormattedMessage id="device.tensiometer.name" defaultMessage="Tensiometer" />
                break;
            case "scaleWeight" :
                to_display = <FormattedMessage id="patientConstants.weight" defaultMessage="Weight" />
                break;
            case "pain" :
                to_display = <FormattedMessage id="patientConstants.pain" defaultMessage="Pain" />
                break;
            case "EQ5D" :
            case "EQ5DHealthscale" :
                to_display = <FormattedMessage id="eq5d.form.title.main" defaultMessage="Health Questionnaire (EQ5D)" />
                break;
            case "SF36" :
                to_display = <FormattedMessage id="sf36.form.title.main" defaultMessage="Health Questionnaire (SF36)" />
                break;
            case "MDASI" :
                to_display = <FormattedMessage id="mdasi.form.title.main" defaultMessage="Health Questionnaire (MDASI)" />
                break;
            case "Alimentation" :
                to_display = <FormattedMessage id="alimentation.form.title.main" defaultMessage="Health Questionnaire (Nourishment)" />
                break;
            case "NIVRate" :
                to_display = <FormattedMessage id="patientConstants.breathingRate" defaultMessage="Breathing rate" />
                break;
            case "NIVLeak" :
            case "NIVUsage" :
                to_display = <FormattedMessage id="device.niv.name" defaultMessage="Breathing" />
                break;
            case "OxiRate" :
                to_display = <FormattedMessage id="patientConstants.oxigenFlowRate" defaultMessage="Oxigen flow" />
                break;
            case "OxiUsage" :
                to_display = <FormattedMessage id="device.oxigentherapy.name" defaultMessage="Breathing" />
                break;
            case "AHI" :
                to_display = <FormattedMessage id="patientConstants.ahi" defaultMessage="AHI" />
                break;
            case "Leak95" :
                to_display = <FormattedMessage id="patientConstants.leak95" defaultMessage="Leak 95" />
                break;
        }
        return (
            <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', fontSize: "30px", fontWeight: 'bold'}}>
                {to_display}
            </div>
        )
    }

    //Function to render input components
    return(
        <div
            className={classes.popup_background}
            style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
            onClick={props.onClose}
        >
            <div
                style={{ width:"85vw", height: "85vh", display: "flex", flexDirection: "column"}}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="submit-form" style={{ width:"100%", height: "100%", borderRadius: "5px", position: "relative", display: "flex", flexDirection: "column"}}>
                    {props.onClose && (
                        <button
                            onClick={props.onClose}
                            style={{ position: 'absolute', top: 10, right: 10, zIndex: 10, background: '#fff', border: '1px solid #ccc', borderRadius: '50%', fontSize: 18, fontWeight: 'bold', lineHeight: 1, cursor: 'pointer', color: '#DB2828', width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.15)' }}
                            title={props.inside_props && props.inside_props.intl ? props.inside_props.intl.formatMessage({ id: 'button.close', defaultMessage: 'Fermer' }) : 'Fermer'}
                        >×</button>
                    )}
                    {titleSelection()}
                    <br/>
                    <div style={{ flex: 1, minHeight: 0, width: "100%" }}>
                        {graphSelection()}
                    </div>
                    <br/>
                </div>
            </div>
        </div>
    );
}

export default withStyles(Constants.styles)(GraphPopup);
